module.exports = {"switchLan":"切换中文"}


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/en-US.json
// module id = q6PX
// module chunks = 1